import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-search-input",
  templateUrl: "./search-input.component.html",
  styleUrl: "./search-input.component.scss",
})
export class SearchInputComponent {
  @Input() iconName: string = "icon-search-grey";
  @Output() searchTextChange = new EventEmitter<any>();

  searchText: any = null;
  private debounceTimeout: any = null;

  onSearchInputChange(event: any) {
    this.searchText = event.target.value;
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    this.debounceTimeout = setTimeout(() => {
      this.searchTextChange.emit(this.searchText);
    }, 600); // 600ms debounce, adjust as needed
  }

  clearSearch() {
    this.searchText = "";
  }
}
